import React, {PureComponent} from "react"

import Validation from "@irati/utils/validation"
import {ScreenContext} from "@irati/utils/validation/ScreenContext"

import ButtonRouterLink from "../ButtonRouterLink"

interface Props {
  onClick: () => void
}

class ValidationButtonRouterLink extends PureComponent<Props> {
  static contextType = ScreenContext
  declare context: React.ContextType<typeof ScreenContext>

  handleClick = (e) => {
    const {onClick} = this.props
    return Validation.validate(this.context)
      .then(() => {
        return onClick(e)
      })
      .catch((err) => {
        err.component?.input?.focus?.()
      })
  }

  render() {
    return <ButtonRouterLink {...this.props} onClick={this.handleClick} />
  }
}

export default ValidationButtonRouterLink
